export function sparklinePath(values, width = 60, height = 20) {
  if (!values || !values.length) return { d: "", trendUp: false, trendDown: false };
  if (values.length === 1) {
    const y = height / 2;
    return { d: `M0,${y} L${width},${y}`, trendUp: false, trendDown: false };
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const stepX = width / (values.length - 1);
  const d = values
    .map((v, i) => {
      const x = i * stepX;
      const y = height - ((v - min) / range) * height;
      return `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");
  const first = values[0];
  const last = values[values.length - 1];
  return { d, trendUp: last > first, trendDown: last < first };
}

export function Sparkline({ values, width = 60, height = 20, color = "hsl(217,100%,59%)" }) {
  const { d } = sparklinePath(values, width, height);
  if (!d) return null;
  return (
    <svg width={width} height={height} className="inline-block overflow-visible" aria-hidden="true">
      <path d={d} fill="none" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
